__turbopack_context__.v({
  "adornmentAfter": "NotificationCell-module__w0ASGW__adornmentAfter",
});
